import React from 'react'
import { FormattedDate } from 'react-intl'
import { toDate } from 'date-fns-tz'

import type { VALID_DATE_INTL_FORMATS } from './constants'
import { DATE_INTL_FORMAT_DEFAULT, formatMappings } from './constants'

export type DateIntlProps = {
  value: string | number | Date
  format?: (typeof VALID_DATE_INTL_FORMATS)[number]
}

const DateIntl = ({ value, format = DATE_INTL_FORMAT_DEFAULT }: DateIntlProps) => {
  const props = formatMappings[format] || formatMappings[DATE_INTL_FORMAT_DEFAULT]

  return <FormattedDate value={toDate(value)} {...props} />
}

export default DateIntl
